export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="40" height="40" rx="11" fill="#0B7285" />
    <path
      d="M13 11v18"
      stroke="#fff"
      strokeWidth="3.4"
      strokeLinecap="round"
    />
    <path
      d="M25.5 12.5L15.8 20.5L26.5 29.5"
      stroke="#fff"
      strokeWidth="3.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M30.5 7.5l.95 2.3 2.3.95-2.3.95-.95 2.3-.95-2.3-2.3-.95 2.3-.95.95-2.3z"
      fill="#A7E3DC"
    />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display font-semibold text-lg tracking-tight ${
          light ? "text-white" : "text-brand-ink"
        }`}
      >
        Kay's Carpet Cleaning
      </span>
      <span
        className={`text-[11px] tracking-[0.18em] uppercase mt-1 ${
          light ? "text-white/70" : "text-brand-muted"
        }`}
      >
        Gold Coast · 7+ Years Experience
      </span>
    </span>
  </span>
);
